var exports = {
  "gP": "EmbedVideo.module__videoOverlay___eFZTaU",
  "yH": "EmbedVideo.module__playButtonWrapper___eFZTaU",
  "SK": "EmbedVideo.module__thumbnailPlaceholder___eFZTaU",
  "aO": "EmbedVideo.module__thumbHashPlaceholder___eFZTaU",
  "mZ": "EmbedVideo.module__metadataProbe___eFZTaU",
  "tN": "EmbedVideo.module__blurContainer___eFZTaU",
  "rj": "EmbedVideo.module__blurContent___eFZTaU",
  "UF": "EmbedVideo.module__blurInner___eFZTaU",
  "Y3": "EmbedVideo.module__blurThumbnail___eFZTaU",
  "il": "EmbedVideo.module__mediaContainer___eFZTaU",
  "AA": "EmbedVideo.module__mobileContainer___eFZTaU",
  "SY": "EmbedVideo.module__videoPlayerWrapper___eFZTaU",
  "s": "EmbedVideo.module__videoPlayerBlock___eFZTaU",
  "Qh": "EmbedVideo.module__videoPlayerFill___eFZTaU",
  "hz": "EmbedVideo.module__inlineVideo___eFZTaU",
  "nD": "EmbedVideo.module__inlineMuteButton___eFZTaU",
};

module.exports = exports;
